import '../styles/base.css'
import { addStylesheet } from './dom'

export * from './Color'
export * as componentApi from './componentApi'
export * from './contextmenu'
export * as cookie from './cookie'
export * as customElement from './customElement'
export * as date from './date'
export * as dom from './dom'
export * as draggable from './draggable'
export * as position from './position'
export * from './file'
export * from './framework'
export * from './serverMessage'
export * from './signals'
export * from './stories'
export * from './theme'
export * as toast from './toast'
export * from './tooltip'
export * from './directives'
export * from './translate'
export * from './util'
export * from './visibleWith'
export * from './store'
export * from './windowManager'
export * from './DropdownContext'
export * from 'solid-js'

export type { DateTimeString } from './date'

addStylesheet(`./common.bundle.css`)

declare global {
    interface Window {
        ST: any;
    }
}